"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8221],{

/***/ 78221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19521);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36357);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63409);
/* harmony import */ var _layouts_standalone_elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50360);
/* harmony import */ var _truck_anchor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75689);
/* harmony import */ var _truck_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48721);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13135);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-top: ",
        "px;\n  min-height: calc(100vh - ",
        "px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: auto;\n  width: fit-content;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_layouts_standalone_elements__WEBPACK_IMPORTED_MODULE_5__/* .CenterContainer */ .H).withConfig({
    componentId: "sc-ff7efa5d-0"
})(_templateObject(), function(props) {
    return props.theme.spacing.cozy * 6;
}, function(props) {
    return props.theme.spacing.cozy * 6;
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_truck_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ff7efa5d-1"
})(_templateObject1());
var ServerErrorScreen = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_4__/* .StandaloneLayout */ .y2, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .InfoErrorBox */ .UB, {
                imageSrc: _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .images.ERROR_VENDOR_NOT_AVAILABLE */ .Wc.ERROR_VENDOR_NOT_AVAILABLE,
                imageAlt: "Vendor not available",
                title: "Tienda no disponible",
                description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        "Lo sentimos, no hemos encontrado la tienda que buscabas. Si eres un visitante de esta tienda intenta m\xe1s tarde, si eres el due\xf1o ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_anchor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            href: _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .riqraInfo.helpCenter */ .eR.helpCenter,
                            children: "contacta a soporte."
                        })
                    ]
                }),
                action: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                    color: "secondary",
                    forwardedAs: "a",
                    href: "https://riqra.com/?utm_source=tiendas&utm_medium=error&utm_campaign=error_tiendas",
                    children: "Crea tu tienda en riqra.com"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ServerErrorScreen);


/***/ })

}]);